import { createGraphqlApiHandler } from 'api/apollo-client'
import graphqlApi from 'api/graphql-api'
import projectApis from 'api/project'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { createApiHandler } from 'helpers/apiHandler'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'

const types = {
  GET_PROJECT_LIST: createActionsSet.api('home.get-project-list'),
  GET_POPULAR_PROJECT_LIST: createActionsSet.api('home.get-popular-project-list'),
  GET_NEW_PROJECT_LIST: createActionsSet.api('home.get-new-project-list'),
  GET_TOP_RATED_LIST: createActionsSet.api('home.get-top-rated-list'),
  GET_MEGA_GAME_CONTRACTS: createActionsSet.api('home.get-mega-game-contracts'),
  GET_TOTAL_PARTICIPANTS: createActionsSet.api('home.get-total-participants'),
  GET_POPULAR_SPINS: createActionsSet.api('home.get-popular-spins'),
}
const getProjectList =
  ({
    pageSize,
    page,
    chainId,
    tokenAddress,
    ownerAddress,
    search,
    active,
    feature,
    infoVerify,
    auditVerify,
    emailVerify,
    sortby,
    order,
  }: {
    pageSize: number
    page: number
    chainId: number
    tokenAddress?: string
    ownerAddress?: string
    search?: string
    active?: number
    feature?: number
    infoVerify?: number
    auditVerify?: number
    emailVerify?: number
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created'
    order?: 'asc' | 'desc'
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({
      type: types.GET_PROJECT_LIST.REQUEST,
      payload: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify,
        auditVerify,
        emailVerify,
        sortby,
        order,
      },
    })
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        projectApis.getProjectList(
          pageSize,
          page,
          chainId,
          tokenAddress,
          ownerAddress,
          search,
          active,
          feature,
          infoVerify,
          auditVerify,
          emailVerify,
          sortby,
          order,
        ),
      )
      dispatch({ type: types.GET_PROJECT_LIST.SUCCESS, payload: response })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_PROJECT_LIST.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getPopularProjects =
  ({
    pageSize,
    page,
    chainId,
    tokenAddress,
    ownerAddress,
    search,
    active,
    feature,
    infoVerify,
    auditVerify,
    emailVerify,
    sortby,
    order,
  }: {
    pageSize: number
    page: number
    chainId: number
    tokenAddress?: string
    ownerAddress?: string
    search?: string
    active?: number
    feature?: number
    infoVerify?: number
    auditVerify?: number
    emailVerify?: number
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created'
    order?: 'asc' | 'desc'
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({
      type: types.GET_POPULAR_PROJECT_LIST.REQUEST,
      payload: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify,
        auditVerify,
        emailVerify,
        sortby: 'total_participant',
        order,
      },
    })
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        projectApis.getProjectList(
          pageSize,
          page,
          chainId,
          tokenAddress,
          ownerAddress,
          search,
          active === 1 ? active : undefined,
          feature === 1 ? feature : undefined,
          infoVerify === 1 ? infoVerify : undefined,
          auditVerify === 1 ? auditVerify : undefined,
          emailVerify === 1 ? emailVerify : undefined,
          'total_participant',
          order,
        ),
      )
      dispatch({
        type: types.GET_POPULAR_PROJECT_LIST.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_POPULAR_PROJECT_LIST.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getNewestProjects =
  ({
    pageSize,
    page,
    chainId,
    tokenAddress,
    ownerAddress,
    search,
    active,
    feature,
    infoVerify,
    auditVerify,
    emailVerify,
    sortby,
    order,
  }: {
    pageSize: number
    page: number
    chainId: number
    tokenAddress?: string
    ownerAddress?: string
    search?: string
    active?: number
    feature?: number
    infoVerify?: number
    auditVerify?: number
    emailVerify?: number
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created'
    order?: 'asc' | 'desc'
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({
      type: types.GET_NEW_PROJECT_LIST.REQUEST,
      payload: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify,
        auditVerify,
        emailVerify,
        sortby: 'created',
        order,
      },
    })
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        projectApis.getProjectList(
          pageSize,
          page,
          chainId,
          tokenAddress,
          ownerAddress,
          search,
          active === 1 ? active : undefined,
          feature === 1 ? feature : undefined,
          infoVerify === 1 ? infoVerify : undefined,
          auditVerify === 1 ? auditVerify : undefined,
          emailVerify === 1 ? emailVerify : undefined,
          sortby,
          order,
        ),
      )
      dispatch({ type: types.GET_NEW_PROJECT_LIST.SUCCESS, payload: response })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_NEW_PROJECT_LIST.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getTopRatedList =
  ({
    pageSize,
    page,
    chainId,
    tokenAddress,
    ownerAddress,
    search,
    active,
    feature,
    infoVerify,
    auditVerify,
    emailVerify,
    sortby,
    order,
  }: {
    pageSize: number
    page: number
    chainId: number
    tokenAddress?: string
    ownerAddress?: string
    search?: string
    active?: number
    feature?: number
    infoVerify?: number
    auditVerify?: number
    emailVerify?: number
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created'
    order?: 'asc' | 'desc'
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({
      type: types.GET_TOP_RATED_LIST.REQUEST,
      payload: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify: 1,
        auditVerify: 1,
        emailVerify: 1,
        sortby: 'rating',
        order,
      },
    })
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        projectApis.getProjectList(
          pageSize,
          page,
          chainId,
          tokenAddress,
          ownerAddress,
          search,
          active,
          feature,
          1,
          1,
          1,
          'total_participant',
          order,
        ),
      )
      dispatch({ type: types.GET_TOP_RATED_LIST.SUCCESS, payload: response })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_TOP_RATED_LIST.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const getMegaGameContracts = () => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_MEGA_GAME_CONTRACTS.REQUEST })
  dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createGraphqlApiHandler(dispatch, getState)
    const response = await handleApi(graphqlApi.getMegaGameContracts({}))
    dispatch({
      type: types.GET_MEGA_GAME_CONTRACTS.SUCCESS,
      payload: response,
    })
  } catch (error) {
    dispatch(appLoadingFeatureActions.finish())
    dispatch({ type: types.GET_MEGA_GAME_CONTRACTS.FAILED, payload: error })
  } finally {
    dispatch(appLoadingFeatureActions.finish())
  }
}
const getTotalParticipants = () => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_TOTAL_PARTICIPANTS.REQUEST })
  dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createGraphqlApiHandler(dispatch, getState)
    const response = await handleApi(graphqlApi.getTotalParticipants({}))
    dispatch({
      type: types.GET_TOTAL_PARTICIPANTS.SUCCESS,
      payload: response,
    })
  } catch (error) {
    dispatch(appLoadingFeatureActions.finish())
    dispatch({ type: types.GET_TOTAL_PARTICIPANTS.FAILED, payload: error })
  } finally {
    dispatch(appLoadingFeatureActions.finish())
  }
}
const getPopularSpins = () => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_POPULAR_SPINS.REQUEST })
  dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createGraphqlApiHandler(dispatch, getState)
    const response = await handleApi(graphqlApi.getPopularSpin({ title: '' }))
    dispatch({
      type: types.GET_POPULAR_SPINS.SUCCESS,
      payload: response,
    })
  } catch (error) {
    dispatch({ type: types.GET_POPULAR_SPINS.FAILED, payload: error })
    dispatch(appLoadingFeatureActions.finish())
  } finally {
    dispatch(appLoadingFeatureActions.finish())
  }
}
export const homeActions = {
  types,
  getProjectList,
  getPopularProjects,
  getNewestProjects,
  getTopRatedList,
  getMegaGameContracts,
  getTotalParticipants,
  getPopularSpins,
}
